import{a as o}from"./chunk-57UERI5J.js";import n from"axios";function a(e){if(e instanceof n.Cancel)console.warn(`Request canceled: "${e.message}"`);else throw o(e)}export{a};
//# sourceMappingURL=chunk-HDV5ANXE.js.map